import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { applyStyle } from '../utils';
import { select } from '../../utils/selection';
import { p } from '../../mark/utils';
export var Image = function Image(options, context) {
  var coordinate = context.coordinate,
    document = context.document;
  return function (points, value, defaults) {
    var defaultColor = defaults.color,
      rest = __rest(defaults, ["color"]);
    var _value$color = value.color,
      color = _value$color === void 0 ? defaultColor : _value$color,
      _value$src = value.src,
      src = _value$src === void 0 ? '' : _value$src,
      _value$size = value.size,
      size = _value$size === void 0 ? 32 : _value$size,
      _value$transform = value.transform,
      transform = _value$transform === void 0 ? '' : _value$transform;
    var _options$width = options.width,
      width = _options$width === void 0 ? size : _options$width,
      _options$height = options.height,
      height = _options$height === void 0 ? size : _options$height;
    var _points = _slicedToArray(points, 1),
      _points$ = _slicedToArray(_points[0], 2),
      x0 = _points$[0],
      y0 = _points$[1]; // Support percentage width, height.
    var _coordinate$getSize = coordinate.getSize(),
      _coordinate$getSize2 = _slicedToArray(_coordinate$getSize, 2),
      w = _coordinate$getSize2[0],
      h = _coordinate$getSize2[1];
    width = typeof width === 'string' ? p(width) * w : width;
    height = typeof height === 'string' ? p(height) * h : height;
    var x = x0 - Number(width) / 2;
    var y = y0 - Number(height) / 2;
    return select(document.createElement('image', {})).call(applyStyle, rest).style('x', x).style('y', y).style('img', src).style('stroke', color).style('transform', transform).call(applyStyle, options).style('width', width).style('height', height).node();
  };
};
Image.props = {
  defaultEnterAnimation: 'fadeIn',
  defaultUpdateAnimation: 'morphing',
  defaultExitAnimation: 'fadeOut'
};